import React, { useEffect, useRef, useState } from 'react';
import '../../styles/Header.css';
import LandingHorneLogo from '../../assets/logos/BDOgs-white.svg';
import LandingHeaderProfile from '../../assets/logos/LandingHeaderProfile.svg';
import '../../styles/ChatHeader.css';
import '../../styles/Content.css';
import LogoutButton from './LogoutButton';

const Header = ({ logoUrl }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Don't close dropdown if clicking inside a MUI Dialog/Modal
      if (event.target.closest('.MuiDialog-root') || event.target.closest('.MuiModal-root')) {
        return;
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="header-top">
      <div className="headerHorneLogo">
        <img
          src={logoUrl || LandingHorneLogo}
          alt="Logo"
          className="landingHorneLogo"
          width={250}
        />
      </div>
      <div className="headerSpace" />
      <div
        className="headerProfileLogo"
        onClick={() => setIsDropdownVisible((prev) => !prev)}
        ref={dropdownRef}
      >
        <img
          src={LandingHeaderProfile}
          alt="LandingHeaderProfile"
          className="landingHeaderProfile"
        />

        {isDropdownVisible && (
          <div className="dropdown-contentHeader">
            <div className="logout-version">
              <div className="logoutContainer">
                <LogoutButton variant="text" fullWidth showIcon />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
